import $ from 'jquery'

$(document).ready(function() {
  dhsv_vc_new()
})

function dhsv_vc_new() {
  $('.dhsv_vc_new').each(function() {})
}
